import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useToggle } from '@infl-ts/util-hooks';
import { Close as CloseIcon } from '@mui/icons-material';
import { Box, Button, Dialog, DialogContent, DialogTitle, IconButton, Slide } from '@mui/material';
import { forwardRef } from 'react';
import { Translation } from 'react-i18next';
import { Tooltip } from '../tooltip';
import { BadgesProgress } from './index';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var BadgesModalButton = function BadgesModalButton(_ref) {
  var children = _ref.children,
      buttonProps = _objectWithoutProperties(_ref, _excluded);

  var _useToggle = useToggle(),
      _useToggle2 = _slicedToArray(_useToggle, 2),
      isOpen = _useToggle2[0],
      _useToggle2$ = _useToggle2[1],
      on = _useToggle2$.on,
      off = _useToggle2$.off;

  return /*#__PURE__*/_jsxs(Box, {
    "data-element": "Box",
    "data-component": "BadgesModalButton",
    "data-source-file": "modal.tsx",
    children: [/*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
      variant: "text",
      onClick: on
    }, buttonProps), {}, {
      "data-element": "Button",
      "data-component": "BadgesModalButton",
      "data-source-file": "modal.tsx",
      children: children
    })), /*#__PURE__*/_jsx(BadgesProgressModal, {
      isOpen: isOpen,
      onClose: off,
      "data-element": "BadgesProgressModal",
      "data-source-file": "modal.tsx"
    })]
  });
};
var Transition = /*#__PURE__*/forwardRef(function Transition(props, ref) {
  return /*#__PURE__*/_jsx(Slide, _objectSpread({
    direction: "up",
    ref: ref
  }, props));
});
export var BadgesProgressModal = function BadgesProgressModal(_ref2) {
  var isOpen = _ref2.isOpen,
      onClose = _ref2.onClose;
  return /*#__PURE__*/_jsxs(Dialog, {
    PaperProps: {
      sx: {
        width: 1,
        maxWidth: '100vw'
      }
    },
    TransitionComponent: Transition,
    open: isOpen,
    "aria-labelledby": "badges-progress",
    "data-element": "Dialog",
    "data-component": "BadgesProgressModal",
    "data-source-file": "modal.tsx",
    children: [/*#__PURE__*/_jsx(Translation, {
      "data-element": "Translation",
      "data-component": "BadgesProgressModal",
      "data-source-file": "modal.tsx",
      children: function children(t) {
        return /*#__PURE__*/_jsxs(Box, {
          sx: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          },
          children: [/*#__PURE__*/_jsx(DialogTitle, {
            sx: {
              pr: 0,
              fontSize: function fontSize(t) {
                return t.typography.h3.fontSize;
              },
              flex: 'unset'
            },
            children: t('Badges and Levels Progress')
          }), /*#__PURE__*/_jsx(Tooltip, {
            title: t('Close'),
            children: /*#__PURE__*/_jsx(IconButton, {
              onClick: onClose,
              sx: {
                m: 2,
                p: 0,
                color: function color(t) {
                  return t.palette.text.primary;
                }
              },
              children: /*#__PURE__*/_jsx(CloseIcon, {})
            })
          })]
        });
      }
    }), /*#__PURE__*/_jsx(DialogContent, {
      dividers: true,
      sx: {
        px: 0
      },
      "data-element": "DialogContent",
      "data-source-file": "modal.tsx",
      children: /*#__PURE__*/_jsx(BadgesProgress, {
        "data-element": "BadgesProgress",
        "data-source-file": "modal.tsx"
      })
    })]
  });
};